/* Copyright Information: Created by BuyGroup */
import React, { useState, useEffect, useRef } from "react";
import { Collapse, Button, Row, Col, Label, Input } from "reactstrap";
import { Link, useParams } from "react-router-dom";
import { connect } from "react-redux";
import { getCategory } from "../actions/category";
import { savePrice } from "../actions/savePrice";
import InputRange from "react-input-range";
import "react-input-range/lib/css/index.css";
import { useHistory } from "react-router";

const CategoryFilter = (props) => {
  const backClick = () => {
    document.getElementById("filter").style.left = "-365px";
  };

  let { id } = useParams();
  const history = useHistory();

  // Get values directly from URL params
  const getUrlParams = () => {
    const params = new URLSearchParams(window.location.search);
    return {
      min: params.get("min") || 0,
      max: params.get("max") || null,
      zipCode: params.get("zipCode") || "",
      accessCode: params.get("accessCode") || ""
    };
  };

  const [price, setPrice] = useState({ min: 0, max: null });
  const [category_id, setCategory] = useState(props.category_id);
  const [isBrandOpen, setIsBrandOpen] = useState(true);
  const [accessCodeDetails, setAccessCodeDetails] = useState(props.accessCode || "");

  const toggleBrand = () => setIsBrandOpen(!isBrandOpen);

  // Initialize price from URL params
  useEffect(() => {
    const { min, max } = getUrlParams();
    setPrice({ min: parseInt(min) || 0, max: max ? parseInt(max) : null });
    // initialize access code input from url if present
    const { accessCode } = getUrlParams();
    setAccessCodeDetails(accessCode || "");
  }, []);

  // Update price when URL changes
  useEffect(() => {
    const { min, max } = getUrlParams();
    setPrice({ min: parseInt(min) || 0, max: max ? parseInt(max) : null });
  }, [window.location.search]);

  const priceChange = (value) => {
    value.min = value.min < 0 ? 0 : value.min;
    setPrice(value);
    let data = { price: value, category_id: category_id };
    props.savePrice(data);
  };

  const onCompletePrice = (price) => {
    const { zipCode, accessCode } = getUrlParams();
    let url = window.location.pathname;
    const params = new URLSearchParams();

    if (zipCode) params.set("zipCode", zipCode);
    if (accessCode) params.set("accessCode", accessCode);
    if (price.min > 0) params.set("min", price.min);
    if (price.max && price.max > 0) params.set("max", price.max);

    const queryString = params.toString();
    if (queryString) {
      url += `?${queryString}`;
    }

    history.push(url);
  };

  const onCompleteZipCode = (zipCode) => {
    let url = window.location.pathname;
    const params = new URLSearchParams();

    // preserve access code if present (from input or existing URL)
    const existingAccessCode = accessCodeDetails || getUrlParams().accessCode;
    if (zipCode) params.set("zipCode", zipCode);
    if (existingAccessCode) params.set("accessCode", existingAccessCode);
    if (price.min > 0) params.set("min", price.min);
    if (price.max && price.max > 0) params.set("max", price.max);

    const queryString = params.toString();
    if (queryString) {
      url += `?${queryString}`;
    }

    history.push(url);
  };

  const onCompleteAccessCode = (accessCode) => {
    let url = window.location.pathname;
    const params = new URLSearchParams();
    // preserve zipCode if present in URL
    const existingZip = getUrlParams().zipCode || "";
    if (existingZip) params.set("zipCode", existingZip);
    if (accessCode) params.set("accessCode", accessCode);
    if (price.min > 0) params.set("min", price.min);
    if (price.max && price.max > 0) params.set("max", price.max);
    const queryString = params.toString();
    if (queryString) {
      url += `?${queryString}`;
    }
    history.push(url);
  };

  /* This Function will clear the filter */
  const clearFilter = () => {
    setPrice({ min: 0, max: null });
    let data = { price: { min: 0, max: null }, category_id: category_id };
    props.savePrice(data);
    history.push("/");
  };

  const debounce = (func, delay) => {
    let timeoutId;
    return (...args) => {
      clearTimeout(timeoutId);
      timeoutId = setTimeout(() => func.apply(null, args), delay);
    };
  };

  const debouncedOnChangeComplete = debounce(onCompleteZipCode, 1000);
  // Use a ref-based timeout for access code so the debounced handler is stable across renders
  const accessCodeTimeoutRef = useRef(null);

  // clear access code timeout on unmount
  useEffect(() => {
    return () => {
      if (accessCodeTimeoutRef.current) {
        clearTimeout(accessCodeTimeoutRef.current);
      }
    };
  }, []);

  const { zipCode } = getUrlParams();

  return (
    <>
      <div className="zip-code-format">
        <Label
          htmlFor="recipient-name"
          className="col-form-label"
        >
          Zip Code
        </Label>
        <Input
          type="number"
          className="form-control zip-code-format"
          name="zipCode"
          placeholder="Search by Zip Code"
          defaultValue={zipCode}
          onChange={(event) => {
            const value = event.target.value;
            if (value) {
              debouncedOnChangeComplete(value);
            } else {
              debouncedOnChangeComplete("");
            }
          }}
        />
      </div>

      <div className="zip-code-format my-2">
        <Label htmlFor="access-code" className="col-form-label">
          Access Code
        </Label>
        <Input
          type="text"
          className="form-control"
          name="accessCode"
          id="access-code"
          placeholder="Enter access code"
          value={accessCodeDetails}
          onChange={(event) => {
            const v = event.target.value;
            setAccessCodeDetails(v);
            if (accessCodeTimeoutRef.current) {
              clearTimeout(accessCodeTimeoutRef.current);
            }
            accessCodeTimeoutRef.current = setTimeout(() => {
              onCompleteAccessCode(v);
            }, 1000);
          }}
        />
      </div>

      <Row className="flex-nowrap">
        <Col md="6">
          <div className="theme-card">
            <h5 className="">Filter</h5>
          </div>
        </Col>
        <Col md="6">
          <div className="theme-card justify-content-end">
            <Button onClick={clearFilter} type="submit" color="primary" className="clear-category-button">
              Clear
            </Button>
          </div>
        </Col>
      </Row>

      {price.max > 0 && (
        <div className="theme-card">
          {/* <h6 className="">Price: {price.min + " To " + price.max}</h6> */}
        </div>
      )}

      <div className="collection-filter-block creative-card creative-inner">
        <div className="collection-mobile-back d-none" onClick={backClick}>
          <span className="filter-back">
            <i className="fa fa-angle-left" aria-hidden="true"></i>
            back
          </span>
        </div>
        <div className="collection-collapse-block border-0 open">
          <h3 className="collapse-block-title" onClick={toggleBrand}>
            Category
          </h3>
          <Collapse isOpen={isBrandOpen}>
            <div className="collection-collapse-block-content">
              <div className="collection-brand-filter">
                <ul className="category-list">
                  {props.category.map((category, index) => {
                    return (
                      <li key={index}>
                        <Link
                          to={`/category/${category.category_id}`}
                          style={{
                            color: category.category_id == id ? "red" : "",
                          }}
                        >
                          {category.category_name}
                        </Link>
                        <ul className="sub-category-list">
                          {category.sub_category.map(
                            (subCategory, subIndex) => {
                              return (
                                <li key={subIndex}>
                                  <Link
                                    to={`/category/${subCategory.category_id}`}
                                    style={{
                                      color:
                                        subCategory.category_id == id
                                          ? "red"
                                          : "",
                                    }}
                                  >
                                    --{subCategory.category_name}
                                  </Link>
                                </li>
                              );
                            }
                          )}
                        </ul>
                      </li>
                    );
                  })}
                </ul>
              </div>
            </div>
          </Collapse>
        </div>
      </div>

      <div className="collection-collapse-block border-0 open">
        <h3 className="collapse-block-title">price</h3>
        <div className="collection-collapse-block-content">
          <div className="wrapper mt-3">
            <div className="range-slider">
              <InputRange
                maxValue={5000}
                minValue={0}
                value={price}
                onChange={(value) => priceChange(value)}
                onChangeComplete={() => onCompletePrice(price)}
              />
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

const mapStateToProps = (state) => {
  console.log("state :----", state);
  return {
    category: state.category.category,
    price: state.savePrice.price,
    category_id: state.savePrice.category_id,
  };
};

const mapDispatchToProps = {
  getCategory,
  savePrice,
};

export default connect(mapStateToProps, mapDispatchToProps)(CategoryFilter);
/* Copyright Information: Created by BuyGroup */